import * as types from './types'
import http from '../../utils/http'
import Vue from 'vue'

const vue = new Vue()

const state = {
  /*
  * 仓库费用配置
  * */
  warehouseList: [],
  warehouseFilterList: [], // 用来做过滤
  warehouseMask: 0,
  // costProject: '', // 收费项目筛选
  // costType: '', // 费用类型筛选
  projectSelect: [], // 收费类型下拉框
  dimensionSelect: [], // 计算维度下拉框
  durationSelect: [], // 时长类型下拉框
  // 不同收费类型下拉框计算方式
  chargingSelect: {
    storageSelect: [],
    dockSelect: [],
    runSelect: [],
    envelopeSelect: [],
    individualSelect: []
  },
  // 费用配置编辑回显
  warehouseEdit: {},
  // 字典表type
  type: '',
  storehouseList: [], // 配送仓点列表
  generalConfig: {}
}

const actions = {
  /*
  * 仓库费用
  * */
  // 获取列表
  [types.GETWAREHOUSECOST] (context, params) {
    http.fetch('/api/warehouseCost/getWarehouseCost', params).then(data => {
      data.type = params.costProject === '' && params.costType === ''
      context.commit(types.GETWAREHOUSECOST, data)
    })
  },
  // 新增仓库费用配置
  [types.WAREHOUSECOSTADD] (context, params) {
    http.fetch('/api/warehouseCost/add', params, 'application/json').then(data => {
      context.commit(types.WAREHOUSECOSTADD, data)
    })
  },
  // 仓库费用配置编辑
  [types.WAREHOUSECOSTEDIT] (context, params) {
    http.fetch('/api/warehouseCost/getCostById', params).then(data => {
      context.commit(types.WAREHOUSECOSTEDIT, data)
    })
  },
  // 仓库费用配置更新
  [types.WAREHOUSECOSTUPDATECOST] (context, params) {
    http.fetch('/api/warehouseCost/updateCost', params, 'application/json').then(data => {
      context.commit(types.WAREHOUSECOSTUPDATECOST, data)
    })
  },
  // 仓库费用配置删除
  [types.WAREHOUSECOSTDEL] (context, params) {
    http.fetch('/api/warehouseCost/delCost', params).then(data => {
      context.commit(types.WAREHOUSECOSTDEL, data)
    })
  },
  // 保存
  [types.GETWAREHOUSECOSTSAVE] (context, params) {
    http.fetch('/api/warehouseCost/setCost', params, 'application/json').then(data => {
      context.commit(types.GETWAREHOUSECOSTSAVE, data)
    })
  },
  // 字典表下拉框
  [types.GETCHILDS] (context, params) {
    http.fetch('/api/dict/getChild', params).then(data => {
      state.type = params.type
      context.commit(types.GETCHILDS, data)
    })
  },
  // 配送仓点下拉框
  
 [types.YCDISPATCHPLATFORMPOINT] (context, params) { 
    http.fetch('/api/ycDispatchPlatformPoint/owned', params).then(data => { 
      context.commit(types.YCDISPATCHPLATFORMPOINT, data)     }) },
  // [types.YCDISPATCHPLATFORMPOINT] (context, params) {
  //   http.fetch('/api/ycDispatchPlatformPoint/all', params).then(data => {
  //     context.commit(types.YCDISPATCHPLATFORMPOINT, data)
  //   })
  // },
  // 通用设置
  [types.GENERALCONFIG] (context, params) {
    http.fetch('/api/warehouseCost/generalConfig', params).then(data => {
      context.commit(types.GENERALCONFIG, data)
    })
  },
  // 获取通用设置详情
  [types.GETGENERALCONFIG] (context, params) {
    http.fetch('/api/warehouseCost/wareHouseCodeGeneralConfig', params).then(data => {
      context.commit(types.GETGENERALCONFIG, data)
    })
  }
}

const mutations = {
  /*
  * 仓库费用
  * */
  // 获取列表
  [types.GETWAREHOUSECOST] (state, data) {
    state.warehouseList = data.obj
    if (data.type) {
      state.warehouseFilterList = data.obj
    }
  },
  // 新增费用配置
  [types.WAREHOUSECOSTADD] (state, data) {
    console.log(data, '新增费用配置')
    if (data.code === 200) {
      state.warehouseMask = 1
      vue.$message({
        showClose: true,
        message: '新增成功',
        type: 'success'
      })
    } else {
      vue.$message({
        showClose: true,
        message: data.message,
        type: 'error'
      })
    }
  },
  // 仓库费用配置编辑
  [types.WAREHOUSECOSTEDIT] (state, data) {
    if (data.code === 200) {
      if (data.obj.smallestRule) {
        data.obj.smallestRule = JSON.parse(data.obj.smallestRule)
      }
      if (data.obj.ycWarehouseCost) {
        data.obj.ycWarehouseCost.smallestRule = JSON.parse(data.obj.ycWarehouseCost.smallestRule)
        for (const key in data.obj.ycWarehouseCost) {
          data.obj[key] = data.obj.ycWarehouseCost[key]
        }
      }
      state.warehouseEdit = data.obj
    } else {
      state.warehouseMask = -1
    }
  },
  // 仓库费用配置更新
  [types.WAREHOUSECOSTUPDATECOST] (state, data) {
    console.log(data, '仓库费用配置更新')
    if (data.code === 200) {
      state.warehouseMask = 1
      vue.$message({
        showClose: true,
        message: '编辑成功',
        type: 'success'
      })
    } else {
      vue.$message({
        showClose: true,
        message: data.message,
        type: 'error'
      })
    }
  },
  // 仓库费用配置删除
  [types.WAREHOUSECOSTDEL] (state, data) {
    console.log(data, '仓库费用配置删除')
    if (data.code === 200) {
      state.warehouseMask = 1
      vue.$message({
        showClose: true,
        message: '删除成功',
        type: 'success'
      })
    } else {
      vue.$message({
        showClose: true,
        message: data.message,
        type: 'error'
      })
    }
  },
  // 保存
  [types.GETWAREHOUSECOSTSAVE] (state, data) {
    if (data.code === 200) {
      state.warehouseMask = 1
      vue.$message({
        showClose: true,
        message: '保存成功',
        type: 'success'
      })
    }
  },
  // 字典表下拉框
  [types.GETCHILDS] (state, data) {
    if (state.type === 'project') {
      state.projectSelect = []
      data.obj.forEach(item => {
        // 其他费用过滤掉
        if (item.code === 'COST_PRO_OTHER' || item.name === '其他费用') return false

        state.projectSelect.push(item)
      })
    } else if (state.type === 'dimension') {
      state.dimensionSelect = data.obj
    } else if (state.type === 'computed') {
      state.chargingSelect = {
        storageSelect: [],
        dockSelect: [],
        runSelect: [],
        envelopeSelect: [],
        individualSelect: []
      }
      data.obj.forEach((item) => {
        if (item.name === '平方/天' || item.name === '箱/天' || item.name === '立方/天' || item.name === '板/天') {
          state.chargingSelect.storageSelect.push(item)
        }
        if (item.name === '箱' || item.name === '重量/体积') {
          state.chargingSelect.dockSelect.push(item)
        }
        if (item.name === '重量/体积' || item.name === '箱' || item.name === '趟' || item.name === '板') {
          state.chargingSelect.runSelect.push(item)
        }
        if (item.name === '板') {
          state.chargingSelect.envelopeSelect.push(item)
        }
        if (item.name === '个') {
          state.chargingSelect.individualSelect.push(item)
        }
      })
    } else if (state.type === 'duration') {
      state.durationSelect = data.obj
    }
    console.log(data, '字典表下拉框')
  },
  // 配送仓点列表
  [types.YCDISPATCHPLATFORMPOINT] (state, data) {
    state.storehouseList = data.obj
  },
  // 通用设置
  [types.GENERALCONFIG] (state, data) {
    if (data.code === 200) {
      vue.$message({
        showClose: true,
        message: '保存成功',
        type: 'success'
      })
      state.warehouseMask = 1
    }
  },
  // 获取通用设置详情
  [types.GETGENERALCONFIG] (state, data) {
    state.generalConfig = data.obj
  }
}

export default {
  state, actions, mutations
}



// WEBPACK FOOTER //
// ./src/store/costConfigure/index.js